import { vesselCardStyles } from "../constants/vessel-card-styles.constants";
import { VesselCardDetail } from "../models/vessel-card.models";
import { ReactNode } from "react";
import { twMerge } from "tailwind-merge";

interface VesselCardDetailPanelProps {
  title: string;
  icon: ReactNode;
  details: VesselCardDetail[];
  dataTest: string;
}

// Renders the four compact Power BI information tables with one consistent label/value layout.
const VesselCardDetailPanel = ({ title, icon, details, dataTest }: VesselCardDetailPanelProps) => (
  <section data-test={dataTest} className={vesselCardStyles.surface}>
    <h2 className={twMerge(vesselCardStyles.sectionTitle, "mb-4 flex items-center gap-2")}>
      <span className="text-green">{icon}</span>
      {title}
    </h2>
    <dl className="space-y-2.5">
      {details.map((detail) => (
        <div key={detail.label} className="grid grid-cols-[minmax(110px,0.85fr)_minmax(0,1.15fr)] gap-3">
          <dt className={vesselCardStyles.fieldLabel}>{detail.label}</dt>
          <dd className="text-sm font-medium leading-5 text-gray-900 dark:text-gray-100">{detail.value}</dd>
        </div>
      ))}
    </dl>
  </section>
);

export default VesselCardDetailPanel;
